import { Typography, toNumberString } from '@client/toolkit';
import { useTranslation } from 'react-i18next';
import { ChangePercentage } from '../../components/change-percentage';
import { MetricCard } from '../../components/metric-card';

export function ReportingOccupancyRateCard({
  title,
  value,
  showDirection,
  loading,
}: {
  title: string;
  value: number;
  showDirection?: boolean;
  loading?: boolean;
}) {
  const { t } = useTranslation('reporting');

  return (
    <MetricCard title={title} isLoading={loading}>
      <span className="flex items-baseline gap-2">
        {showDirection ? (
          <ChangePercentage value={value} size="3xl" />
        ) : (
          <Typography variantFontSize="h2">{toNumberString(value)}%</Typography>
        )}
        <Typography variantFontSize="sub" className="text-white/60">
          {t('ofTotalArea')}
        </Typography>
      </span>
    </MetricCard>
  );
}
